<template>
    <div class="email-sharing-form print-overlay">
        <el-dialog :visible.sync="dialogVisible" :show-close="false" top="64px" :append-to-body="true" custom-class="print-overlay__dialog print-overlay__dialog--small">
            <div class="print-overlay__content">
                <div class="print-overlay__head no-print">
                    <span class="bold-label">Route per Mail teilen</span>
                    <div class="print-overlay__close" @click="closeClickHandler">
                        <Icon><IconClose/></Icon>
                    </div>
                </div>
                <div class="email-sharing-form__main">
                    <SmrInput
                        :value="email"
                        inputType="email"
                        placeholder="E-Mail Addresse*"
                        :error="emailInputError"
                        @change="emailChangeHandler">
                    </SmrInput>
                    <div v-if="emailInputError" class="email-sharing-form__error caption red">Pflichtfeld</div>
                    <div class="email-sharing-form__text-preview copy">
                        Sehr geehrtes Mitglied!
                        <br><br>
                        Anbei finden Sie Ihre persönliche ÖAMTC Routenempfehlung.<br>
                        <a :href="sharingUrl" target="_blank">
                            <SmrButton size="small" class="email-sharing-form__text-preview__button">Route anzeigen</SmrButton>
                        </a>
                        <br><br>
                        Mit freundlichen Grüßen
                        Ihr ÖAMTC
                        <br><br>
                        Hinweis: Dem Absender kann nicht geantwortet werden. Haben Sie weitere Fragen zur Routenplanung wenden Sie sich gerne an <a href="mailto:routenplaner@oeamtc.at">routenplaner@oeamtc.at</a>
                    </div>
                    <div v-if="emailSendError" class="email-sharing-form__api-error caption red">
                        {{  emailSendError  }}
                    </div>
                    <SmrButton class="email-sharing-form__button" @click.native="sendEmail">Mail absenden</SmrButton>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import eventBus from '@/utils/event-bus';
import * as api from '@/api';
import SmrInput from '@/components/form/SmrInput.vue'
import Icon from '@/components/Icon.vue'
import IconClose from '@/components/icons/IconClose.vue'
import SmrButton from '@/components/SmrButton.vue'

export default {
    components: {
        SmrInput,
        Icon,
        IconClose,
        SmrButton
    },
    data() {
        return {
            dialogVisible: false,
            sharingUrl: false,
            email: '',
            emailInputError: false,
            emailSendError: false,
        }
    },
    mounted() {
        this.addListeners()
    },
    beforeDestroy() {
        this.removeListeners()
    },
    methods: {
        closeClickHandler() {
            this.closeDialog();
        },
        showEmailSharingFormHandler(e) {
            this.emailSendError = false
            this.createShortUrl(e)
            this.showDialog()
        },
        emailChangeHandler(e) {
            this.email = e
            this.emailInputError = this.email === '' || !this.validateEmail(this.email)
        },
        addListeners() {
            eventBus.$on('showEmailSharingForm', this.showEmailSharingFormHandler);
        },
        removeListeners() {
            eventBus.$off('showEmailSharingForm', this.showEmailSharingFormHandler);
        },
        closeDialog() {
            this.dialogVisible = false;
        },
        showDialog() {
            this.dialogVisible = true;
        },
        validateEmail(email) {
            const emailRegex = /^\S+@\S+$/;
            return emailRegex.test(email);
        },
        async createShortUrl(link) {
            const shortUrl  = await api.shortlinks.shortenURL(link)
            this.sharingUrl = shortUrl.data.shortUrl
        },
        async sendEmail() {
            this.emailSendError = false
            if(this.email === '' || !this.validateEmail(this.email)) {
                this.emailInputError = true
                return
            }

            try {
                const response = await api.email.shareUrlViaEmail(this.email, this.sharingUrl)
                console.log(response)
                eventBus.$emit('showSuccessMessage', { message: 'Die E-Mail wurde erfolgreich versendet' , closeAfter: 2000 })
            } catch(error) {
                console.error(error)
                this.emailSendError = error.response?.data?.message
                if(error.response?.data?.errors.length) this.emailSendError = `${this.emailSendError || ''} ${error.response?.data?.errors.map(e => e.value).join(' ')}`
            }
        }
    }
}
</script>

<style lang="scss">
.email-sharing-form {
    &__main {
        padding: 24px 30px 30px;
    }

    &__error {
        padding: 0 16px;
        margin-top: 2px;
    }

    &__text-preview {
        padding: 7px 16px;
        background: $color-black-005;
        border-radius: 8px;
        margin-top: 6px;

        &__button {
            max-width: 290px;
            margin-top: 10px;
        }
    }

    &__api-error {
        margin-top: 16px;
    }

    &__button {
        max-width: 290px;
        margin: 32px auto 0;
    }
}
</style>